import $ from 'jquery';
import Cookies from 'js-cookie';

// Override link behavior within dropdown menu associated with search form for resource type,
// appending values to hidden form element.
function searchSelector(options) {
/*
    options = {
        selector: '#t-selector a',  // A sizzle selector for the onclick event
        name: 't',                  // The form element name to update
        all: None
    }
*/

    $(options.selector).on('click', (e) => {
        // stop the link from acting like a link
        e.preventDefault();

        // set variables
        const $search = $('#search');
        const $selected = $(e.target);
        const selectedText = $selected.attr('data-pretty');
        const $dropdown = $selected.parents('.dropdown');
        let scopeValue = $selected.attr('data-scope');

        // used for resource type selector, several options search multiple type facets.
        // Appends needed wildcard.
        if ($selected.is('.all')) {
            scopeValue += '*';
        }

        // find any existing selectors that have been set and remove them.
        $search.find('input.search-modifier').remove();

        // create a new hidden element to pass to the form as a hidden field
        const $passHidden = $('<input>', { class: 'search-modifier',
                                           type: 'hidden',
                                           name: options.name,
                                           value: scopeValue,
                                      });

        // add the new hidden field to the form
        $search.append($passHidden);

        // for type selectors, if the user selected all, don't set anything
        if (scopeValue === options.all) {
            $search.find('input.search-modifier')
            .remove();
        }

        // Set the visible text of the dropdown menu to whatever was selected
        $dropdown.find('.selected')
            .empty()
            .append(selectedText);

        // close the dropdown
        if ($dropdown.is('.open')) {
            $dropdown.removeClass('open');
        }

        // Send focus back to the text input
        $('#search-submit').focus();
    });
}

function getSearchTypeDefault() {
  const searchTypeToSet = document.querySelector('#search-type-selected');

  if (searchTypeToSet) {
    const typeValue = Cookies.get('aubreyDefaultSearchPretty');

    if (typeof typeValue !== 'undefined') {
        searchTypeToSet.textContent = decodeURIComponent(typeValue);
    }
  }
}

function setSearchTypeDefault() {
    const $search = $('#search');

    $('#search button.search__scope-default-setter').on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        const $sibling = $this.prev('a');

        $search.find('i.fa-star').toggleClass('fa-star fa-star-o');
        $this.find('i.fa').toggleClass('fa-star fa-star-o');
        $sibling.trigger('click');

        const setDefaultSearchType = $sibling.data('scope');
        const setDefaultSearchPretty = $sibling.data('pretty');

        Cookies.set('aubreyDefaultSearchType', setDefaultSearchType, { expires: 365 });
        Cookies.set('aubreyDefaultSearchPretty', setDefaultSearchPretty, { expires: 365 });
    });
}

// For Set focus to search on page load for homepage
function focusOnSearchInput() {
    $('#q').focus();
}

// If user submits blank search, order by newest added 1st.
function orderBlankSearches() {
    $('#primary-search, #search').on('submit', function () {
        const $this = $(this);
        const searchTerm = $this.find('input[name="q"]').val();
        if (searchTerm === '') {
            $this.find('input[name="sort"]').val('added_d');
        }
    });
}

// Generate Sample Searches for the homepage, returned as random set of 5 items.
function makeSampleSearches(searchSuggestions) {
    const suggestions = searchSuggestions;

    // randomly select 4 items from the suggestions
    let curIndex = suggestions.length;
    let tmpVal;
    let randIndex;

    while (curIndex !== 0) {
        randIndex = Math.floor(Math.random() * curIndex);
        curIndex -= 1;
        tmpVal = suggestions[curIndex];
        suggestions[curIndex] = suggestions[randIndex];
        suggestions[randIndex] = tmpVal;
    }
    const suggestionsSubset = suggestions.slice(0, 5);
    const searchPath = '/search/';
    const $q = $('#q');
    const $fa = $('#search-fa');
    const $samples = $('<span id="samples" class="samples" />');
    const $container = $('#sample-searches').addClass('animate__animated animate__fadeInDown')
                                            .append('<strong class="sample--label">Sample Searches: </strong>');

    // for each suggestion, print to the screen
    for (const suggested of suggestionsSubset) {
        const $sample = $('<a>', {
            class: 'btn btn-sm btn-inverse-ghost sample--item',
            'aria-label': `Sample Search: ${suggested.term}`,
            href: `${searchPath}?q=${suggested.term}&t=${suggested.tValue}&sort=${suggested.sort}&src=sample`,
            text: suggested.term,
        });

        $sample.appendTo($samples);
    }

    $samples.appendTo($container);

    // on suggestion click, emulate search form submit
    $('.hd__sample-search').on('click', function () {
        $q.val($(this).text());
        $fa.removeClass('fa-search').addClass('fa-circle-o-notch fa-spin');
    });
}

function buildAdvancedSearch() {
    const $advancedForm = $('#advanced-search-form');

    // Save the initial state of the live select form
    // components, so that we can reset the form later.
    const liveSelectState = [
        $advancedForm.find('#institutions option'),
        $advancedForm.find('#collections option'),
        $advancedForm.find('#languages option'),
        $advancedForm.find('#types option'),
    ];

    $.fn.extend({
        formatSearchString(searchText, options) {
            const settings = {
                before: '',
                after: '',
            };
            if (options) {
                $.extend(settings, options);
            }
            $(this).empty().append(settings.before + searchText + settings.after);
        },
    });

    $advancedForm.on('change', 'select.refine', function () {
        $(this).addClass('selectedRefinement');

        const selectedLimiter = $(this).find('option:selected').attr('selected', 'selected').val();
        let institutionLimiter = $('#institutions.selectedRefinement').find(':selected').val();
        let collectionsLimiter = $('#collections.selectedRefinement').find(':selected').val();
        let languagesLimiter = $('#languages.selectedRefinement').find(':selected').val();
        let typesLimiter = $('#types.selectedRefinement').find(':selected').val();
        const effectTheseSelects = $('select.refine').not(this);

        if (institutionLimiter === undefined) {
          institutionLimiter = '';
        }
        if (collectionsLimiter === undefined) {
          collectionsLimiter = '';
        }
        if (languagesLimiter === undefined) {
          languagesLimiter = '';
        }
        if (typesLimiter === undefined) {
          typesLimiter = '';
        }

        const success = function (data) {
            $(effectTheseSelects).find('option:gt(0)').remove();
            $(effectTheseSelects).each(function () {
              const thisSelector = $(this).attr('id');
              let options = '';

              for (const i of data[thisSelector]) {
                if (i.current) {
                  options += `<option selected="selected" value=${i.option_val}>${i.option_text}</option>`;
                } else {
                  options += `<option value=${i.option_val}>${i.option_text}</option>`;
                }
              }
              $(this).append(options);
            });
          };

        $.ajax({
          url: '/search/advanced_search/search_fields.json',
          dataType: 'json',
          data: `types=${typesLimiter}&languages=${languagesLimiter}&collections=${collectionsLimiter}&institutions=${institutionLimiter}`,
          cache: false,
          success,
        });
    });

    $advancedForm.on('keyup', 'input.q__field', function () {
        $('#filler').hide();
        const searchText = $(this).val();
        const inputName = $(this).attr('id');
        const $filled = $(`#fill-${inputName}`);

        if (inputName === 'q') {
          $filled.formatSearchString(searchText);
        }

        if (inputName === 'q1' || inputName === 'q2' || inputName === 'q3') {
          $filled.formatSearchString(searchText, { before: '"', after: '"' });
        }

        if (inputName === 'q4' || inputName === 'q5' || inputName === 'q6') {
          const whiteSpace = new RegExp(/\s/);
          if (whiteSpace.test(searchText)) {
            $filled.formatSearchString(searchText, { before: ' -"', after: '"' });
          } else {
            $filled.formatSearchString(searchText, { before: ' -' });
          }
        }

        if (inputName === 'nlow') {
          $filled.formatSearchString(searchText, { before: ' date:' });
        }

        if (inputName === 'nhi') {
          $filled.formatSearchString(searchText, { before: '-' });
        }

        if ($('#nlow').val() !== '' && $('#nhi').val() === '') {
          $('#fill-nhi').formatSearchString('', { before: '- *' });
        }
        if ($('#nhi').val() !== '' && $('#nlow').val() === '') {
          $('#fill-nlow').formatSearchString('', { before: 'date:*' });
        }
        if (searchText === '') {
          $filled.empty();
        }
    });


    $advancedForm.submit(() => {
        $('input.proximity-phrase').each(function () {
            // Remove all quotes, including smart quotes.
            const proximityText = $(this).val();
            const quotelessText = proximityText.replace(/['"\u2018\u2019\u201C\u201D]|\(|\)|~\d*/g, '');

            if (proximityText.length) {
                const proximityCount = $('#proximity-count').val();
                $(this).val(`("${quotelessText}"~${proximityCount})`);
            }
        });

        $('input.groupify').each(function () {
            const searchText = $(this).val();
            const cleanText = searchText.replace(/\(|\)/g, '');

            if (searchText.length) {
                $(this).val(`(${cleanText})`);
            }
        });
    });

    // $advancedForm.on('click', '#advanced-search-reset', function(){
    //
    // Reset the query display.
    //   $('.query').empty();
    //   $('#filler').hide();
    //
    //   Reset the select options.
    //   $.each(liveSelectState, function( key, value ) {
    //    $(value.selector).parent()
    //      .empty()
    //      .append(value)
    //   });
    //
    //   Set the selected option.
    //   $('select option').attr('selected', false);
    //   $('select option:first').attr('selected', true);
    //
    // });
    //
    // Update hidden field values on form submit
    // $advancedForm.submit(function() {
    //     let $hiddenFields = $(this).find('.advanced__selector--t');
    //
    //     $hiddenFields.each(function() {
    //        $(this).val(function() {
    //            return $('#switch-advanced-t').find('option:selected').data('apply');
    //        })
    //     });
    // })
}

function focusHeaderSearch() {
    if ($('#hd-search-toggle').length) {
        $('#header-search-options').on('shown.bs.dropdown', () => {
            $('#hd-q').focus();
        });
    }
}

export {
    searchSelector,
    getSearchTypeDefault,
    setSearchTypeDefault,
    focusOnSearchInput,
    makeSampleSearches,
    orderBlankSearches,
    buildAdvancedSearch,
    focusHeaderSearch,
};
